import { takeLatest, all, put, call } from 'redux-saga/effects';
import * as calls from './calls';
import * as reducerActions from '../../reducers/localidadesEntregaReducer/actions';
import * as Notifications from '../../components/Common/notification';
import * as layoutActions from '../../reducers/layoutReducer/actions';

function* genGetAllLocalidadesEntrega() {
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Obteniendo localidades de entrega' }));
        let localidades = yield call(calls.GetAllLocalidadesEntrega);
        yield put(reducerActions.setLocalidadesEntrega(localidades));
    } catch (error) {
        if (error.message) {
            Notifications.showError(error.message);
        }
    } finally {
        yield put(layoutActions.setLoading({ show: false }));
    }
}

function* genGetLocalidadEntrega(e) {
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Cargando localidad de entrega' }));
        let localidad = yield call(calls.GetLocalidadEntrega, e.payload.idLocalidadEntrega);
        yield put(reducerActions.saveLocalidadEntrega(localidad));
    } catch (error) {
        if (error.message) {
            Notifications.showError(error.message);
        }
    } finally {
        yield put(layoutActions.setLoading({ show: false }));
    }
}

function* genGetLocalidadEntregaByNombre(e) {
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Cargando localidad de entrega' }));
        let localidad = yield call(calls.getLocalidadEntregaByNombre, e.payload.nombre);
        yield put(reducerActions.saveLocalidadEntrega(localidad));
    } catch (error) {
        if (error.message) {
            Notifications.showError(error.message);
        }
    } finally {
        yield put(layoutActions.setLoading({ show: false }));
    }
}

function* genSaveLocalidadEntrega(e) {
    try {
        yield call(calls.saveLocalidadEntrega, e.payload);
        if (e.payload.idLocalidadEntrega !== 0) {
            Notifications.showSuccess("Localidad de entrega actualizada");
        } else {
            Notifications.showSuccess("Localidad de entrega creada");
        }
        window.history.back();
    } catch (error) {
        Notifications.showError(error.message);
    }
}

function* genDeleteLocalidadEntrega(e) {
    try {
        yield put(layoutActions.setLoading({ show: true, message: 'Eliminando localidad de entrega' }));
        yield call(calls.deleteLocalidadEntrega, e.payload.idLocalidadEntrega);
        yield put(layoutActions.setLoading({ show: false }));
        Notifications.showSuccess("Localidad de entrega eliminada");
        yield put(reducerActions.sagaGetLocalidadesEntrega());
    } catch (error) {
        yield put(layoutActions.setLoading({ show: false }));
        Notifications.showError(error.message || "Error al eliminar la localidad de entrega");
    }
}

function* defaultSaga() {
    yield all([
        takeLatest(reducerActions.SAGA_GET_LOCALIDADES_ENTREGA, genGetAllLocalidadesEntrega),
        takeLatest(reducerActions.SAGA_GET_LOCALIDAD_ENTREGA, genGetLocalidadEntrega),
        takeLatest(reducerActions.SAGA_GET_LOCALIDAD_ENTREGA_BY_NOMBRE, genGetLocalidadEntregaByNombre),
        takeLatest(reducerActions.SAGA_SAVE_LOCALIDAD_ENTREGA, genSaveLocalidadEntrega),
        takeLatest(reducerActions.SAGA_ELIMINAR_LOCALIDAD_ENTREGA, genDeleteLocalidadEntrega),
    ]);
}

export const sagas = [
    defaultSaga
];